interface StorageLike {
  readonly length: number;
  clear(): void;
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

const fakeStorage: StorageLike = (function () {
  let data: { [key: string]: string } = {};

  return {
    get length() {
      return Object.keys(data).length;
    },

    setItem(key: string, value: string): void {
      data[key] = value;
    },

    getItem(key: string): string | null {
      return data[key];
    },

    removeItem(key: string): void {
      delete data[key];
    },

    clear(): void {
      data = {};
    }
  };
})();

const testStr = "__storejs__test__";
type StorageType = "sessionStorage" | "localStorage";

function getStorage(type: StorageType) {
  try {
    const storage = typeof window == "undefined" ? null : window[type];

    if (storage == null) {
      return fakeStorage;
    }

    storage.setItem(testStr, testStr);

    const ok = storage.getItem(testStr) === testStr;

    storage.removeItem(testStr);

    return ok ? storage : fakeStorage;
  } catch {
    return fakeStorage;
  }
}

const localStorage = getStorage("localStorage");
const sessionStorage = getStorage("sessionStorage");

class StorageAdapter {
  storage: StorageLike;

  constructor(storage: StorageLike) {
    this.storage = storage;
  }

  setItem<Type>(key: string, value: Type) {
    try {
      this.storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("error", error);
    }
  }

  getItem<Type>(key: string, fallback: Type) {
    try {
      const raw = this.storage.getItem(key);

      if (raw != null) {
        return JSON.parse(raw);
      } else {
        return fallback;
      }
    } catch (error) {
      console.log("error", error);
      return fallback;
    }
  }

  removeItem(key: string) {
    try {
      this.storage.removeItem(key);
    } catch (error) {
      console.error("error", error);
    }
  }

  clear() {
    try {
      this.storage.clear();
    } catch (error) {
      console.error("error", error);
    }
  }
}

export const LocalStorage = new StorageAdapter(localStorage);
export const SessionStorage = new StorageAdapter(sessionStorage);
export const FakeStorage = new StorageAdapter(fakeStorage);
